import PropTypes from 'prop-types';
import React from 'react';
import { Button, ButtonGroup, ButtonToolbar, Col, Row } from 'react-bootstrap';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import notificationPopUp from '../../NotificationPopUp';

import commonFunctions from '../../commonFunctions';

import * as authenticationActions from '../../actions/authenticationActions';
import * as commonActions from '../../actions/commonActions';
import * as networkActions from '../../actions/networkActions';
import * as reportingActions from '../../actions/reportingActions';

import AirBnbDateTimePicker from '../common/airBnbDatepicker/AirBnbDateTimePicker';
import SelectInput from '../common/SelectInput';

class RendicontazionePage extends React.Component {

    constructor(props, context) {
        super(props, context);

        var today = new Date();
        today.setHours(12, 0, 0, 0);
        var startDate = new Date(today);
        startDate.setMonth(startDate.getMonth() - 1);
        this.state = {
            commonState: this.props.commonState,
            authenticationState: this.props.authenticationState,
            networks: [],
            seletedNetworkProducts: [],
            filters: {
                startDate: startDate.toISOString(),
                endDate: today.toISOString(),
                networkId: null,
                productId: null
            },
            result: {
                operations: [],
                perProductOperations: []
            }
        };

        if (!authenticationActions.verifyAuthentication(this.props.authenticationState, this.props.history)) {
            return;
        }

        this.updateState = this.updateState.bind(this);
        this.loadProducts = this.loadProducts.bind(this);
        this.search = this.search.bind(this);
        this.rendicontazioneExport = this.rendicontazioneExport.bind(this);
    }

    componentDidMount() {
        if (this.state.networks === null || this.state.networks.length === 0) {
            this.props.networkActions.loadAllNetworks(this.props.pagingModel).then((networksFromServer) => {

                const networks = networksFromServer.map(
                    (value) => {
                        return { value: value.id, text: value.businessName };
                    });

                this.setState(Object.assign({}, this.state, { networks }));
            }).catch(error => {
                notificationPopUp.error('Problemi nel caricamento dei Networks');
            });
        }

        if (!this.state.commonState.configuration || this.state.commonState.configuration.cities === null || this.state.commonState.configuration.cities.length === 0) {
            this.props.commonActions.loadConfiguration().then(() => {
            }).catch(error => {
                notificationPopUp.error('Problemi nel caricamento della configurazione base');
            });
        }
    }

    updateState(event) {
        var names = event.target.name.split('_');

        if (names[0] === 'filters') {
            const filters = Object.assign({}, this.state.filters);
            filters[names[1]] = event.target.value;
            this.setState(Object.assign({}, this.state, { filters }));

            if (names[1] === 'networkId') {
                this.loadProducts(event.target.value);
            }
        }
    }

    loadProducts(id) {
        this.props.networkActions.loadNetworkProducts(id).then((products) => {
            this.setState(Object.assign({}, this.state, {
                seletedNetworkProducts: products.map(
                    (value) => {
                        return { value: value.id, text: value.name };
                    })
            }));
        }).catch(error => {
            this.setState(Object.assign({}, this.state, { seletedNetworkProducts: [] }));
            notificationPopUp.error(error);
        });
    }

    search() {
        console.log('Search');
        this.props.reportingActions.loadRendicontazione(this.state.filters).then((result) => {
            this.setState((state) => { return { result } });
        }).catch(error => {
            notificationPopUp.error(error);
        });
    }

    gridPrintMoney(cell, row) {
        return commonFunctions.numberToItalianEuroFormat(cell);
    }

    rendicontazioneExport() {
        this.props.reportingActions.exportRendicontazione(this.state.filters).catch(error => {
            notificationPopUp.error('Problemi nell\'export ');
        });
    }

    render() {
        return (
            <div className="container">
                <h1>Rendicontazione Generica</h1>
                <div className="panel panel-default x-panel-gray">
                    <div className="panel-heading">Filtri</div>
                    <div className="panel-body">
                        <Row>
                            <Col xs={12} md={4}>
                                <AirBnbDateTimePicker
                                    name='filters_startDate'
                                    label="Da"
                                    required={true}
                                    value={this.state.filters.startDate}
                                    onChange={this.updateState} />
                            </Col>
                            <Col xs={12} md={4}>
                                <AirBnbDateTimePicker
                                    name='filters_endDate'
                                    label="A"
                                    required={true}
                                    value={this.state.filters.endDate}
                                    onChange={this.updateState} />
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12} md={4}>
                                <SelectInput
                                    name="filters_networkId"
                                    label="Netowrk"
                                    defaultOptionText=""
                                    defaultOptionValue={''}
                                    value={this.state.filters.network}
                                    options={this.state.networks}
                                    onChange={this.updateState} />
                            </Col>
                            <Col xs={12} md={4}>
                                <SelectInput
                                    name="filters_productId"
                                    label="Piano Mutualistico"
                                    defaultOptionText=""
                                    defaultOptionValue={''}
                                    value={this.state.filters.product}
                                    options={this.state.seletedNetworkProducts}
                                    onChange={this.updateState} />
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12} md={12}>
                                <ButtonToolbar>
                                    <ButtonGroup>
                                        <Button bsStyle='primary' onClick={this.search} >Cerca</Button>
                                    </ButtonGroup>
                                    <ButtonGroup>
                                        <Button bsStyle='primary' onClick={() => this.rendicontazioneExport()} >Export</Button>
                                    </ButtonGroup>
                                </ButtonToolbar>
                            </Col>
                        </Row>
                    </div>
                </div>

                <div className="panel panel-default x-panel-gray">
                    <div className="panel-heading">Operazioni Estratte</div>
                    <div className="panel-body">
                        <BootstrapTable data={this.state.result.operations} striped hover >
                            <TableHeaderColumn isKey dataField='id' hidden>Id</TableHeaderColumn>
                            <TableHeaderColumn dataField='tipo' dataSort>Tipo</TableHeaderColumn>
                            <TableHeaderColumn dataField='quantity' dataSort>Numero Operazioni</TableHeaderColumn>
                            <TableHeaderColumn dataField='totalAmount' dataFormat={this.gridPrintMoney} dataSort>Totale</TableHeaderColumn>
                            <TableHeaderColumn dataField='forwelfareRights' dataFormat={this.gridPrintMoney} dataSort>Provvigioni Forwelfare</TableHeaderColumn>
                            <TableHeaderColumn dataField='sebRights' dataFormat={this.gridPrintMoney} dataSort>Provvigioni Seb</TableHeaderColumn>
                            <TableHeaderColumn dataField='netowrkRights' dataFormat={this.gridPrintMoney} dataSort>Provvigioni Netowrk</TableHeaderColumn>
                            <TableHeaderColumn dataField='supporterRights' dataFormat={this.gridPrintMoney} dataSort>Provvigioni Segnalatore</TableHeaderColumn>
                            <TableHeaderColumn dataField='agentRights' dataFormat={this.gridPrintMoney} dataSort>Provvigioni Operatori</TableHeaderColumn>
                        </BootstrapTable>
                    </div>
                </div>

                <div className="panel panel-default x-panel-gray">
                    <div className="panel-heading">Operazioni per Piano Mutualistico</div>
                    <div className="panel-body">
                        <BootstrapTable data={this.state.result.perProductOperations} striped hover >
                            <TableHeaderColumn isKey dataField='id' hidden>Id</TableHeaderColumn>
                            <TableHeaderColumn dataField='networkName' dataSort>Network</TableHeaderColumn>
                            <TableHeaderColumn dataField='productName' dataSort>Piano Mutualistico</TableHeaderColumn>
                            <TableHeaderColumn dataField='quantity' dataSort>Numero Operazioni</TableHeaderColumn>
                            <TableHeaderColumn dataField='totalAmount' dataFormat={this.gridPrintMoney} dataSort>Totale</TableHeaderColumn>
                            <TableHeaderColumn dataField='forwelfareRights' dataFormat={this.gridPrintMoney} dataSort>Provvigioni Forwelfare</TableHeaderColumn>
                            <TableHeaderColumn dataField='sebRights' dataFormat={this.gridPrintMoney} dataSort>Provvigioni Seb</TableHeaderColumn>
                            <TableHeaderColumn dataField='netowrkRights' dataFormat={this.gridPrintMoney} dataSort>Provvigioni Netowrk</TableHeaderColumn>
                            <TableHeaderColumn dataField='supporterRights' dataFormat={this.gridPrintMoney} dataSort>Provvigioni Segnalatore</TableHeaderColumn>
                            <TableHeaderColumn dataField='agentRights' dataFormat={this.gridPrintMoney} dataSort>Provvigioni Operatori</TableHeaderColumn>
                        </BootstrapTable>
                    </div>
                </div>
            </div>
        );
    }
}

RendicontazionePage.propTypes = {
    authenticationState: PropTypes.object.isRequired,
    commonState: PropTypes.object.isRequired
};

function mapStateToProps(state, ownProps) {
    return {
        commonState: state.commonState,
        authenticationState: state.authenticationState
    };
}

function mapDispatchToProps(dispatch) {
    return {
        commonActions: bindActionCreators(commonActions, dispatch),
        authenticationActions: bindActionCreators(authenticationActions, dispatch),
        networkActions: bindActionCreators(networkActions, dispatch),
        reportingActions: bindActionCreators(reportingActions, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(RendicontazionePage);
